import { OptionForFilter } from "./types/optionForFilterType";

const optionsForSearch: OptionForFilter[] = [
  { value: "unitNumber", label: "unit number" },
  { value: "iluCode", label: "ILU code" },
];

const searchTextFromSearch: OptionForFilter[] = [
  { value: "unitNumber", label: "Enter unit number(s)" },
  { value: "iluCode", label: "Enter ILU code" },
];

export const placeHolderFromOption = (optionValue: string) => {
  if (optionValue === undefined || optionValue === null || optionValue === "")
    return "T";
  return searchTextFromSearch.filter(
    (option) => option.value === optionValue
  )[0].label;
};

export default optionsForSearch;
